import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { cartContentIdsSelector } from '../../../redux/selectors/cartContentSelector';
import CartContent from './CartContent';

const mapStateToProps = () => {
  const selector = createStructuredSelector({
    cartIds: cartContentIdsSelector(),
  });

  return state => selector(state);
};

export default connect(mapStateToProps)(CartContent);
